import { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext.js'
import './Notifications.css'

export default function Notifications() {
  const { apiFetch, admin } = useAuth()

  const [checkinNotify, setCheckinNotify] = useState(false)
  const [loading,       setLoading]       = useState(true)
  const [saving,        setSaving]        = useState(false)
  const [msg,           setMsg]           = useState(null)

  useEffect(() => {
    apiFetch('/api/admin/notification-prefs')
      .then(r => r.json())
      .then(data => {
        setCheckinNotify(data.checkinNotify ?? false)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  const handleToggle = async (val) => {
    const prev = checkinNotify
    setCheckinNotify(val)
    setSaving(true)
    try {
      const res = await apiFetch('/api/admin/notification-prefs', {
        method: 'PUT',
        body:   JSON.stringify({ checkinNotify: val }),
      })
      if (!res.ok) throw new Error()
      setMsg({ type: 'success', text: 'Gespeichert.' })
    } catch {
      setCheckinNotify(prev)
      setMsg({ type: 'error', text: 'Fehler beim Speichern.' })
    } finally {
      setSaving(false)
      setTimeout(() => setMsg(null), 3000)
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1>Benachrichtigungen</h1>
        <p>Persönliche Benachrichtigungseinstellungen für Ihren Account.</p>
      </div>

      {loading ? (
        <div className="loading-state"><span className="spinner" /> Laden…</div>
      ) : (
        <div className="card notif-card">
          <div className="row-between">
            <div>
              <strong className="notif-item-title">Check-in Benachrichtigung</strong>
              <p className="notif-item-desc">
                E-Mail an <strong>{admin?.email}</strong> bei jedem neuen Check-in.
              </p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={checkinNotify}
                disabled={saving}
                onChange={e => handleToggle(e.target.checked)}
              />
              <span className="toggle-slider" />
            </label>
          </div>

          {msg && (
            <div className={`alert ${msg.type === 'success' ? 'alert-success' : 'alert-error'} notif-msg`}>
              {msg.text}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
